import validateForm from '../validate-form/validateForm'

export default (vm) => {
    if(!validateForm(vm)) {
        return
    }
    let allQueryArr = []
    let allTagArr = []

    vm.modbusConfig.pollingGroupArr.forEach((pollingGroupObj) => {
        pollingGroupObj.queryArr.forEach((queryObj) => {
            allQueryArr.push(queryObj)
            queryObj.tagArr.map((tagObj) => {
                allTagArr.push(tagObj)
            })
        })
    })

    let generateServerConfigArr = () => {
        if(vm.loggingMethod === 'ftp') {
            csvArr.push(['FTPServerConfigStart', '', '', '', '', '', '', '', '', '', '', '', ''])

            vm.serverData.ftp.serverArr.forEach((serverObj) => {
                csvArr.push([serverObj.serverAddress, serverObj.portNumber, serverObj.username, serverObj.password, serverObj.dataLoggingPath, serverObj.errorLoggingPath, serverObj.configFilePath, '', '', '', '', '', ''])
            })

            csvArr.push(['FTPServerConfigEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        } else if(vm.loggingMethod === 'http') {
            csvArr.push(['HTTPServerConfigStart', '', '', '', '', '', '', '', '', '', '', '', ''])

            vm.serverData.http.serverArr.forEach((serverObj) => {
                csvArr.push([serverObj.serverAddress, serverObj.portNumber, serverObj.username, serverObj.password, serverObj.dataLoggingPath, serverObj.errorLoggingPath, serverObj.configFilePath, serverObj.ftpserverAddress, serverObj.ftpportNumber, serverObj.ftpusername, serverObj.ftppassword, serverObj.senddatamode, serverObj.jsondataview, '', '', '', '', '', ''])
            })

            csvArr.push(['HTTPServerConfigEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        } else if(vm.loggingMethod === 'cumulocity') {
            csvArr.push(['CUMServerConfigStart', '', '', '', '', '', '', '', '', '', '', '', ''])
            csvArr.push([vm.serverData.cumulocity.serverUrl, vm.serverData.cumulocity.emailLogin, vm.serverData.cumulocity.password, vm.serverData.cumulocity.ftpServerAddress, vm.serverData.cumulocity.ftpPortNumber, vm.serverData.cumulocity.ftpUsername, vm.serverData.cumulocity.ftpPassword, vm.serverData.cumulocity.ftpConfigFilePath, '', '', '', '', ''])
            csvArr.push(['CUMServerConfigEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        } else if(vm.loggingMethod === 'mqtt') {
            csvArr.push(['MQTTServerConfigStart', '', '', '', '', '', '', '', '', '', '', '', ''])
            csvArr.push([vm.serverData.mqtt.hostname, vm.serverData.mqtt.portNumber, vm.serverData.mqtt.username, vm.serverData.mqtt.password, vm.serverData.mqtt.topicName, vm.serverData.mqtt.qos, vm.serverData.mqtt.ftpServerAddress, vm.serverData.mqtt.ftpPortNumber, vm.serverData.mqtt.ftpUsername, vm.serverData.mqtt.ftpPassword, vm.serverData.mqtt.ftpConfigFilePath, vm.serverData.mqtt.senddatamode, vm.serverData.mqtt.jsondataview, ''])
            csvArr.push(['MQTTServerConfigEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        } else if(vm.loggingMethod === 'azure') {
            csvArr.push(['AzureServerConfigStart', '', '', '', '', '', '', '', '', '', '', '', ''])
            csvArr.push([vm.serverData.azure.hostname, vm.serverData.azure.portNumber, vm.serverData.azure.deviceid, vm.serverData.azure.shpolicyname, vm.serverData.azure.shpolicykey, vm.serverData.azure.tokentime, vm.serverData.azure.topicName, vm.serverData.azure.qos, vm.serverData.azure.ftpServerAddress, vm.serverData.azure.ftpPortNumber, vm.serverData.azure.ftpUsername, vm.serverData.azure.ftpPassword, vm.serverData.azure.ftpConfigFilePath, vm.serverData.azure.senddatamode, vm.serverData.azure.jsondataview, ''])
            csvArr.push(['AzureServerConfigEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        }
        generateLoggerDetailsArr()
    }

    let generateSerialDetailsArr = () => {
        csvArr.push(['SerialConfigurationStart', '', '', '', '', '', '', '', '', '', '', '', ''])
        csvArr.push([vm.serialData.databits, vm.serialData.baudrate, vm.serialData.parity, vm.serialData.stopbits, vm.serialData.flowcontrol, '', '', '', '', '', '', '', ''])
        csvArr.push(['SerialConfigurationEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
    }

    let generateLoggerDetailsArr = () => {
        csvArr.push(['ModbusExtraInfoStart', '', '', '', '', '', '', '', '', '', '', '', ''])
        csvArr.push([vm.loggerData.loggerId, vm.loggerData.rtuTimeout, vm.loggerData.tcpTimeout, vm.loggerData.tcpStatus, vm.loggerData.tcpPort, '', '', '', '', '', '', '', ''])
        csvArr.push(['ModbusExtraInfoEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        csvArr.push(['DatabaseSize', vm.loggerData.databaseSize,'',])
        csvArr.push(['PollingGroupStart', '', '', '', '', '', '', '', '', '', '', '', ''])
        generatePollingGroupArr()
    }

    let generatePollingGroupArr = () => {
        vm.modbusConfig.pollingGroupArr.forEach((pollingGroupObj, index) => {
            csvArr.push([`Group${index + 1}Start`, '', '', '', '', '', '', '', '', '', '', '', ''])
            csvArr.push([`Group${index + 1}`, pollingGroupObj.pollingInterval, pollingGroupObj.logType, pollingGroupObj.gpsReportingState, pollingGroupObj.lanReportingState, pollingGroupObj.wanReportingState, pollingGroupObj.cellularReportingState, pollingGroupObj.generalReportingState, '', '', '', '', ''])

            generateQueryArr(pollingGroupObj)

            csvArr.push([`Group${index + 1}End`, '', '', '', '', '', '', '', '', '', '', '', ''])
        })
        csvArr.push(['PollingGroupEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        csvArr.push(['UploadGroupStart', '', '', '', '', '', '', '', '', '', '', '', ''])

        generateUploadGroupArr()
    }

    let generateQueryArr = (pollingGroupObj) => {
        pollingGroupObj.queryArr.forEach((queryObj) => {
            csvArr.push(['QueryStart', '', '', '', '', '', '', '', '', '', '', '', ''])
            csvArr.push([queryObj.queryName, queryObj.slaveId, queryObj.functionCode, queryObj.startAddress, queryObj.numberOfRegisters, queryObj.ipAddress, queryObj.port])

            generateTagArr(queryObj)

            csvArr.push(['QueryEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
        })
    }

    let generateTagArr = (queryObj) => {
        queryObj.tagArr.forEach((tagObj) => {
            csvArr.push([tagObj.tagName, tagObj.tagAddressOffset, tagObj.tagAddressLength, tagObj.tagDatatype, tagObj.tagLinearScalingCoefficientA, tagObj.tagLinearScalingOffsetB, tagObj.tagAlertFlag, tagObj.tagMinimumThreshold, tagObj.tagMaximumThreshold, tagObj.tagMobileNumber, tagObj.tagCriticalTag, tagObj.tagCriticalAlarm, tagObj.tagStoreAsFloat])
        })
    }

    let generateUploadGroupArr = () => {
        vm.modbusConfig.uploadGroupArr.forEach((uploadGroupObj, index) => {
            csvArr.push([`Group${index + 1}Start`, '', '', '', '', '', '', '', '', '', '', '', ''])
            csvArr.push([`Group${index + 1}`, uploadGroupObj.uploadInterval, uploadGroupObj.statusReportingEnabledArr[0], uploadGroupObj.statusReportingEnabledArr[1], uploadGroupObj.statusReportingEnabledArr[2], uploadGroupObj.statusReportingEnabledArr[3], uploadGroupObj.statusReportingEnabledArr[4], uploadGroupObj.statusReportingEnabledArr[5], '', '', '', '', ''])

            generateUploadTagArr(uploadGroupObj)

            csvArr.push([`Group${index + 1}End`, '', '', '', '', '', '', '', '', '', '', '', ''])
        })
        csvArr.push(['UploadGroupEnd', '', '', '', '', '', '', '', '', '', '', '', ''])
    }

    let generateUploadTagArr = (uploadGroupObj) => {
        uploadGroupObj.selectedTagArr.forEach((selectedTagObj) => {
            if(vm.loggingMethod === 'cumulocity') {
                let tagName
                let tagUnitOfMeasurement
                let pollingGroupNumber
                let queryName
                let selectedTagIndex = allTagArr.findIndex((el) => {
                    return el.tagId === selectedTagObj.tagId
                })
                let selectedQueryIndex = allQueryArr.findIndex((el) => {
                    return el.queryId === selectedTagObj.queryId
                })
                let selectedPollingGroupIndex = vm.modbusConfig.pollingGroupArr.findIndex((el) => {
                    return el.pollingGroupId === selectedTagObj.pollingGroupId
                })
                tagName = allTagArr[selectedTagIndex].tagName
                tagUnitOfMeasurement = allTagArr[selectedTagIndex].tagUnitOfMeasurement
                queryName = allQueryArr[selectedQueryIndex].queryName
                pollingGroupNumber = selectedPollingGroupIndex + 1
                csvArr.push([tagName, pollingGroupNumber, queryName, tagUnitOfMeasurement, '', '', '', '', '', '', '', '', ''])
            } else {
                let tagName
                let pollingGroupNumber
                let queryName
                let selectedTagIndex = allTagArr.findIndex((el) => {
                    return el.tagId === selectedTagObj.tagId
                })
                let selectedQueryIndex = allQueryArr.findIndex((el) => {
                    return el.queryId === selectedTagObj.queryId
                })
                let selectedPollingGroupIndex = vm.modbusConfig.pollingGroupArr.findIndex((el) => {
                    return el.pollingGroupId === selectedTagObj.pollingGroupId
                })
                tagName = allTagArr[selectedTagIndex].tagName
                queryName = allQueryArr[selectedQueryIndex].queryName
                pollingGroupNumber = selectedPollingGroupIndex + 1
                csvArr.push([tagName, pollingGroupNumber, queryName, '', '', '', '', '', '', '', '', '', ''])
            }
        })
    }

    let csvArr = [
        ['ConfigurationStart', '', '', '', '', '', '', '', '', '', '', '', '']
    ]

    generateServerConfigArr()

    console.log(csvArr)

    let csvContent = 'data:text/csv;charset=utf-8,'
    csvArr.forEach((row) => {
        let rowStr = row.join(',')
        csvContent += rowStr + '\r\n'
    })

    let encodedUri = encodeURI(csvContent)
    let link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', 'modbus_config.csv')
    document.body.appendChild(link)
    link.click()
}



// WEBPACK FOOTER //
// ./src/generate-csv/generateCsv.js